module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Butt.309bab54.pdf";